module.exports = __webpack_public_path__ + "images/emoji/radio_button.eae6d441a11f361727e1.png";